<template>
  <div class="bank_body">
    <div class="tupian">
      <img src="/6.jpeg">
    </div>
    <!--    <div class="xianshi">限时福利！立减20元</div>-->
    <van-tabs v-model="activeName">
      <van-tab title="课程详情" name="a">
        <div class="kechengxiangqing">
          <div class="biaoti">黄梅戏初级教程</div>
          <div class="laoshi">授课老师：罗超</div>
        </div>
        <div style="width: 100%;height: 9px;background:#f8f8f8; "></div>
        <van-collapse v-model="value">
          <van-collapse-item title="简介" name="1">
            <div class="xiangqing">课程简介</div>
            <div class="xi">黄梅戏与京剧、越剧、评剧 、豫剧并称“中国五大戏曲剧种”，也是安徽省的主要地方戏曲剧种，湖北、江西、福建、浙江、江苏、香港、
              台湾等地亦有黄梅戏的专业或业余的演出团体，
              受到广泛的欢迎
            </div>
          </van-collapse-item>
          <van-collapse-item title="视频目录" name="2">
            <div class="shiping" v-for="(item,index) in 5">
              <div class="xiabiao">{{index+1}}</div>
              <div class="kecheng">黄梅戏第一节</div>
              <div class="bofang"><img src="/bofang.png"></div>
            </div>
          </van-collapse-item>
        </van-collapse>

      </van-tab>
      <van-tab title="评论列表" name="b">
        <div class="pinglun" v-for="item in 2">
          <div class="touxiang"><img src="/6.jpeg"></div>
          <div class="neirong">
            <div class="name">罗超</div>
            <div class="ping">教程很详细，内容也很精彩，值得观看</div>
            <div class="shijian">2020年4月12号</div>
          </div>
        </div>
        <div class="foot">
          <div class="shuru">
            <van-cell-group>
              <van-field v-model="inputt" placeholder="说点你的心得吧"/>
            </van-cell-group>
          </div>
          <div class="anniu">
            <van-button type="primary" size="small">发送</van-button>
          </div>
        </div>
      </van-tab>
<!--      <van-tab title="栏目列表" name="c">-->
<!--        <van-collapse v-model="value">-->
<!--          <van-collapse-item title="视频目录" name="1">-->
<!--            <div class="shiping" v-for="(item,index) in 5">-->
<!--              <div class="xiabiao">{{index+1}}</div>-->
<!--              <div class="kecheng">黄梅戏第一节</div>-->
<!--              <div class="bofang"><img src="/bofang.png"></div>-->
<!--            </div>-->
<!--          </van-collapse-item>-->
<!--          <van-collapse-item title="音频文件" name="2">-->
<!--            <div class="shiping" v-for="(item,index) in 5">-->
<!--              <div class="xiabiao">{{index+1}}</div>-->
<!--              <div class="kecheng">黄梅戏第一节</div>-->
<!--              <div class="bofang"><img src="/bofang.png"></div>-->
<!--            </div>-->
<!--          </van-collapse-item>-->
<!--        </van-collapse>-->
<!--      </van-tab>-->
    </van-tabs>




  </div>
</template>

<script>
    import { Toast } from 'vant';
    export default {
        name: "bank",
        data() {
            return {
                activeName: 'a',
                value: ['1'],
                inputt: ''
            }
        },
        created() {

        },
        methods: {
            goumai() {
                this.$router.push({path: '/Place'})
            },

        }
    }
</script>

<style scoped lang="stylus">
  .bank_body {
    width 100%;
    position relative;

    .kechengxiangqing{
      width 95%;
      margin 10px auto;
      .biaoti{
        font-weight 500;
        font-size 16px;
        color #333333;
        margin-left 5px;
      }
      .laoshi{
        font-weight 500;
        font-size 14px;
        color #ccc;
        margin-left 5px;
        margin-top 10px;
      }
      .cputong{
        font-weight 500;
        font-size 14px;
        color #ccc;
        margin-left 5px;
        margin-top 5px;
      }
      .xianshi{
        /*margin-left 5px;*/
        .xianshiname{
          font-weight 500;
          font-size 14px;
          color #ccc;
          margin-left 5px;
          margin-top 5px;
        }
        .youxiao{
          font-weight 500;
          font-size 14px;
          color #ccc;
          margin-left 5px;
          margin-top 5px;
        }
        .xianjia{
          font-weight 500;
          font-size 14px;
          color #ccc;
          margin-left 5px;
          margin-top 5px;
        }
        .suzhi{
          font-weight 500;
          font-size 14px;
          color #ccc;
          margin-left 5px;
          margin-top 5px;
        }
        .jieshi{
          font-weight 500;
          font-size 14px;
          color #ccc;
          margin-left 5px;
          margin-top 5px;
        }
      }
    }
    .foot {
      width 95%;
      margin auto;
      display flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      position fixed;
      bottom 0px;

      .shuru {
        width 85%;
      }

      .anniu {
        width 10%;
      }
    }

    .tupian {
      width 100%;

      img {
        width 100%;
        height 250px;
      }
    }

    .xiangqing {
      font-weight 500;
      font-size 16px;
      color #333333;
      width 90%;
      margin 10px auto;
    }

    .xi {
      width 90%;
      margin 10px auto;
      line-height 1.5
    }

    .xiangqingtu {
      width 90%;
      margin 10px auto;

      img {
        width 100%;
        height 150px;
      }
    }

    .shiping {
      position relative;
      margin-top 10px;
      border-bottom 1px solid #fafafa;
      height 25px;
      >>> .van-collapse-item__content {
        padding 0px;
      }
      width 90%;
      margin 10px auto;
      display flex;

      .xiabiao {
        margin-right 10px;
      }

      .kecheng {

      }

      .bofang {
        position absolute;
        right 0px;

        img {
          width 20px;
          height 20px;
        }
      }
    }

    .pinglun {
      width 90%;
      margin 10px auto;
      display flex

      .touxiang {
        margin-top 10px;

        img {
          width 50px;
          height 50px;
          border-radius 30px;
        }
      }

      .neirong {
        margin-left 10px;

        .name {
          color #333333;
          font-size 14px;
          font-weight 500
        }

        .ping {
          margin-top 5px;
          color #ccc;
        }

        .shijian {
          margin-top 5px;
          color #ccc;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/video.vue